import {
    SlimPipe,
    DualWieldPipe,
    FreeDualWieldPipe,
    PersonPipe,
    Empty,
    DevSlimPipe,
} from '../helpers/graph_pipeline'
import {
    EmbedDatabase,
    LocalEmbedDatabase,
    LocalEmbedDatabaseV2,
    ActivityAnalysis,
} from '../helpers/recognition'
import * as draw from './canvas_utils'
import TfWorker from '../helpers/tf.worker'

export class GraphicHandler {
    constructor({
        video,
        videoCanvas,
        boxCanvas,
        previewCanvas,
        mainCanvas,
        recordCanvas,
        handleWindowResize,
        eventStateHandler,

        isMotionDetection = false,
        isPersonDetection = false,
        isPersonDetectionBox = false,
        isAutoLowLight = false,
        isNightVision = false,
        sensitivity = 2,
        isFree = true,
        deviceContext = undefined,
    }) {
        this.state = 'init'
        this.handleWindowResize = handleWindowResize
        this.eventStateHandler = eventStateHandler
        this.deviceContext = deviceContext
        this.liveCounter = 0
        this.lastLiveCanvasUpdate = new Date().getTime() - 9999
        this.video_source = video
        this.video_canvas = videoCanvas

        this.previewCanvas = previewCanvas
        this.previewCanvasCtx = previewCanvas.getContext('2d')
        this.mainCanvas = mainCanvas
        this.mainCanvasCtx = mainCanvas.getContext('2d')
        this.boxCanvas = boxCanvas
        this.recordCanvas = recordCanvas
        this.recordCanvasCtx = recordCanvas.getContext('2d')
        this.debug_view = false

        this.pipeline_config = {
            isMotionDetection,
            isPersonDetection,
            isPersonDetectionBox,
            isAutoLowLight,
            isNightVision,
            inZoomMode: false,
            zoomCrood: [
                Number.parseInt(video.videoWidth / 2),
                Number.parseInt(video.videoHeight / 2),
            ],
            zoomScale: 1.0,
            autoLowLightThreshold: {
                dark_threshold: 0.25,
                bright_threshold: 0.35,
            },
            motionThreshold: 600,
            sensitivity,
        }

        this.pipeline = undefined
        this.pipeline_warmup = 0

        this.previewCanvasCtx.fillStyle = '#0A0A0A'
        this.previewCanvasCtx.fillRect(
            0,
            0,
            this.previewCanvas.width,
            this.previewCanvas.width
        )

        this._create_detection_pipeline(video, videoCanvas, boxCanvas, isFree)
        this._create_visual_pipeline(video, videoCanvas, boxCanvas, isFree)

        video.addEventListener('canplay', () => {
            // if video is not ready when contructor is called, video.videoHeight/videoWidth will be 0
            this.pipeline_config.zoomCrood = [
                Number.parseInt(video.videoWidth / 2),
                Number.parseInt(video.videoHeight / 2),
            ]
        })

        this.pipelines = {
            detection_pipeline: this.pipeline,
            visual_pipeline: this.vis_pipeline,
        }
        this.profiles = null
        this.isFree = isFree
        console.log('[GraphicHandler] constrcutor')
    }

    start(progress_callback = undefined) {
        const check_warm = () => {
            // Check is all the pipeline are warmup with certain a mount of force run frames
            let all_warmup = true
            if (Object.values(this.pipelines).length == 0)
                throw Error('Not pipeline found in the current config!')
            let total_progress = 0
            let total_target = 0

            for (const pipe_role in this.pipelines) {
                if (pipe_role != 'visual_pipeline') {
                    const pipe = this.pipelines[pipe_role]
                    const done_warmup = pipe.warmup_steps >= pipe.warmup_target
                    total_progress += pipe.warmup_steps
                    total_target += pipe.warmup_target
                    this.log(
                        `done_warmup: ${pipe_role}, ${done_warmup}, ${pipe.warmup_steps} >= ${pipe.warmup_target}`
                    )
                    all_warmup = all_warmup && done_warmup
                }
            }

            if (progress_callback) {
                total_progress = Number.parseInt(
                    (total_progress / total_target) * 100
                )
                progress_callback(total_progress)
            }
            return all_warmup
        }

        this.log(`graphic_handler.start called ${this.state} ${check_warm()}`)

        for (const pipe of Object.values(this.pipelines)) {
            pipe.on_warmup_update = check_warm
        }

        if (this.state != 'start') {
            const set_and_check_else = () => {
                let all_warmup = check_warm()
                if (all_warmup) {
                    if (this.state != 'start') {
                        this._sync_pipe_config()
                        this.state = 'start'
                        this.vis_pipeline.start_extract_frame()
                        this.pipeline.start_extract_frame()
                    }
                }
            }

            switch (this.state) {
                case 'pause':
                    // Pipelines had successfuly warmup but camera stream and context is swaped
                    this.pipeline.start_extract_frame()
                    this.vis_pipeline.start_extract_frame()
                    this.state = 'start'
                    break
                case 'stop':
                    // Recreate pipeline after workers are terminated
                    if (this.pipeline._use_worker) {
                        this._create_detection_pipeline(
                            this.video_source,
                            this.video_canvas,
                            this.boxCanvas,
                            this.isFree
                        )
                    }
                case 'init':
                    if (check_warm()) {
                        // Pipelines had successfuly warmup before but been paused
                        set_and_check_else()
                    } else {
                        // First time warmup
                        for (const pipe_role in this.pipelines) {
                            if (pipe_role !== 'visual_pipeline') {
                                const pipe = this.pipelines[pipe_role]
                                if (pipe.warmup_steps == 0) {
                                    pipe.on_warmup_finish = set_and_check_else
                                    pipe.warmup()
                                }
                            }
                        }
                    }
                    break
            }
        }
    }

    pause() {
        this.pipeline.stop_frame_extract()
        this.vis_pipeline.stop_frame_extract()
        this.state = 'pause'
    }

    stop() {
        this.pause()
        if (this.pipeline._use_worker) this.pipeline.stop_worker()
        if (this.vis_pipeline._use_worker) this.vis_pipeline.stop_worker()
        if (this.eventStateHandler) this.eventStateHandler.tick('interrupte')
        this.state = 'stop'
    }

    log(...args) {
        if (window.alfredTest2wsxsw2) {
            console.debug(`[${this.constructor.name}] `, ...args)
        }
    }

    log_jitter(pipe_stamp_info) {
        if (this.profiles === null) {
            this.profiles = {}
            for (const pipe of Object.values(this.pipelines)) {
                this.profiles[pipe.type()] = {
                    record_count: 0,
                    jitter_records: [],
                    jitter_record_stamps: [],
                }
            }
        } else {
            const type = pipe_stamp_info.process_pipe
            this.profiles[type].record_count++
            this.profiles[type].jitter_records.push(
                new Date().getTime() - pipe_stamp_info.timestamp
            )
            this.profiles[type].jitter_record_stamps.push(
                pipe_stamp_info.timestamp
            )

            if (this.profiles[type].jitter_records.length > 100) {
                this.profiles[type].jitter_records.shift()
                this.profiles[type].jitter_record_stamps.shift()
            }

            if (
                this.profiles[type].record_count % 100 == 0 &&
                this.profiles[type].record_count > 0
            ) {
                let sum = 0
                for (const v of this.profiles[type].jitter_records) {
                    sum += v
                }
                const m = this.profiles[type].jitter_records.length
                const mean = sum / m
                let variance = 0
                for (const v of this.profiles[type].jitter_records) {
                    variance += Math.pow(v - mean, 2)
                }
                variance /= m
                const esp =
                    this.profiles[type].jitter_record_stamps[m - 1] -
                    this.profiles[type].jitter_record_stamps[0]
                const fps = m / (esp / 1000)
                console.log(
                    `%c ${type} jitter - mean: ${mean}, var: ${variance}, fps: ${fps}`,
                    'color: rgb(200, 120, 1);'
                )
            }
        }
    }

    _create_detection_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let detection_pipeline = null
        if (!isFree) {
            detection_pipeline = new DualWieldPipe(
                video,
                videoCanvas,
                boxCanvas,
                undefined,
                (res) => {
                    res.pipeline_role = 'detection_pipeline'
                    this._event_multipex(res)
                }
            )
        } else {
            detection_pipeline = new FreeDualWieldPipe(
                video,
                videoCanvas,
                boxCanvas,
                undefined,
                (res) => {
                    res.pipeline_role = 'detection_pipeline'
                    this._event_multipex(res)
                }
            )
        }
        this.pipeline = detection_pipeline
    }

    _create_visual_pipeline(video, videoCanvas, boxCanvas, isFree) {
        this.vis_pipeline = new SlimPipe(
            video,
            videoCanvas,
            boxCanvas,
            undefined,
            (res) => {
                res.pipeline_role = 'visual_pipeline'
                this._event_multipex(res)
            }
        )
    }

    send_input_event_to_pipe(event) {
        this.pipeline.send_input_event(event)
        this.vis_pipeline.send_input_event(event)
    }

    send_input_event(name, state) {
        /* 
        Sending external singal from user interactions to graphic pipeline.
        This method accepte following name-state pairs:
            {isPersonDetection: bool}
            {isMotionDetection: bool}
            {isAutoLowLight: bool}
            {isNightVision: bool}
            {isPersonDetectionBox: bool} 
            {ZoomByClick: {
                x: 0.0 < float < 1.0,
                y: 0.0 < float < 1.0
            }}
            {Zoom2: {
                x: 0.0 < float < 1.0,
                y: 0.0 < float < 1.0,
                scale: 1.0 <= float <= 4.0
            }}
            {setAutoLowLightThreshold: {
                dark_threshold: 0.0 < float < 1.0,
                birght_threshold: 0.0 < float < 1.0
            }}
            {setMotionThreshold: 0 < int < 255 * 64 }
        */
        window.logManager.log(`[GraphicHandler] ${name}: ${state}`)
        switch (name) {
            case 'setAutoLowLightThreshold': {
                let threshold = {
                    dark_threshold: 0.18,
                    bright_threshold: 0.24,
                }
                this.send_input_event_to_pipe({
                    set_low_light_threshold: threshold,
                })
                break
            }
            case 'setPersonThreshold': {
                let threshold = 0.45
                if (state === 1) {
                    threshold = 0.6
                } else if (state === 3) {
                    threshold = 0.3
                }
                this.send_input_event_to_pipe({
                    set_person_det_threshold: threshold,
                })
                break
            }
            case 'setMotionThreshold': {
                let threshold = 140
                if (state === 3) {
                    threshold = 80
                } else if (state === 1) {
                    threshold = 200
                }
                this.send_input_event_to_pipe({
                    set_motion_threshold: threshold,
                })
                break
            }
            case 'isPersonDetection': {
                if (state === true) {
                    this.send_input_event_to_pipe({
                        set_person_det: state,
                        set_motion_det: true,
                    })
                } else {
                    this.send_input_event_to_pipe({
                        set_person_det: state,
                        reset_motion_area: true,
                    })
                }
                this.pipeline_config[name] = state
                // NOTE: There maybe record is goign on when PD is turn on which is trigger by motion
                //       , so we will need to sent interrupte singal to update event state to avoid PD+MD video(mixed type)
                if (this.eventStateHandler) {
                    this.eventStateHandler.tick('interrupte')
                }
                break
            }
            case 'isMotionDetection':
                this.send_input_event_to_pipe({ set_motion_det: state })
                this.send_input_event_to_pipe({ reset_motion_area: true })
                this.pipeline_config[name] = state
                if (!state && this.eventStateHandler) {
                    this.eventStateHandler.tick('interrupte')
                } else if (state && this.eventStateHandler) {
                    // flush frames from previous session when turning MD on
                    this.eventStateHandler._record_manager.buffer_holder.flush()
                }
                break
            case 'isAutoLowLight':
                this.send_input_event_to_pipe({ set_low_light_detect: state })
                this.pipeline_config[name] = state
                break
            case 'isNightVision':
                this.send_input_event_to_pipe({ set_low_light_filter: state })
                this.pipeline_config[name] = state
                break
            case 'isPersonDetectionBox':
                this.pipeline_config[name] = state
                break
            case 'ZoomOut':
                this.zoomOut()
                break
            case 'ZoomByClick': {
                const zoomed = this.pipeline_config.inZoomMode
                if (zoomed) {
                    this.zoomOut()
                } else {
                    if (state.clickX > 1.0 || state.clickY > 1.0)
                        throw Error('You should pass normalized coordinate!')
                    const coord = this.pipeline_config.zoomCrood
                    const scale = this.pipeline_config.zoomScale
                    const new_coord = [
                        Number.parseInt(
                            state.clickX * this.video_source.videoWidth
                        ),
                        Number.parseInt(
                            state.clickY * this.video_source.videoHeight
                        ),
                    ]
                    const new_scale = 2
                    const n = 7
                    for (let i = 0; i < n; i++) {
                        this.send_input_event_to_pipe({
                            set_intermed_zoom_coord: [
                                coord[0] + (i / n) * (new_coord[0] - coord[0]),
                                coord[1] + (i / n) * (new_coord[1] - coord[1]),
                            ],
                            set_intermed_zoom_scale:
                                scale + (i / n) * (new_scale - scale),
                        })
                    }
                    this.send_input_event_to_pipe({
                        set_final_zoom_coord: new_coord,
                        set_final_zoom_scale: new_scale,
                    })
                    this.pipeline_config.zoomScale = new_scale
                    this.pipeline_config.zoomCrood = new_coord
                    this.pipeline_config.inZoomMode = true
                }
                return this.pipeline_config.inZoomMode
            }
            case 'Zoom2':
                if (state.x > 1 || state.y > 1)
                    throw Error(
                        `You should pass normalized coordinate! [${state.x}, ${state.y}]`
                    )
                if (state.scale > 4 || state.scale < 1)
                    throw Error(`Invalid zoom scale! ${state.scale}`)
                const new_coord = [
                    Number.parseInt(state.x * this.video_source.videoWidth),
                    Number.parseInt(state.y * this.video_source.videoHeight),
                ]
                const new_scale = state.scale

                if (new_scale < 1 + 1e-5) {
                    this.send_input_event_to_pipe({
                        set_final_zoom_coord: new_coord,
                        set_final_zoom_scale: new_scale,
                    })
                } else {
                    this.send_input_event_to_pipe({
                        set_intermed_zoom_coord: new_coord,
                        set_intermed_zoom_scale: new_scale,
                    })
                }

                this.pipeline_config.zoomScale = new_scale
                this.pipeline_config.zoomCrood = new_coord
                this.pipeline_config.inZoomMode = new_scale > 1 + 1e-5
                return this.pipeline_config.inZoomMode
            case 'setFaceInferenceInterval':
                this.send_input_event_to_pipe({
                    set_face_inference_interval: state,
                })
                break
            case 'setGlobalInfereceInterval':
                this.send_input_event_to_pipe({
                    set_global_inference_interval: state,
                })
                break
            case 'setDebugView':
                this.debug_view = state
                break
            case 'liveCount':
                this.liveCounter = state
                break
            default:
                throw Error(`Unknown graphic pipeline event: ${name}`)
        }
    }

    zoomOut() {
        const zoomed = this.pipeline_config.inZoomMode
        if (zoomed) {
            const coord = this.pipeline_config.zoomCrood
            const scale = this.pipeline_config.zoomScale
            const new_coord = [
                Number.parseInt(this.video_source.videoWidth / 2),
                Number.parseInt(this.video_source.videoHeight / 2),
            ]
            const n = 7
            for (let i = 0; i < n; i++) {
                this.send_input_event_to_pipe({
                    set_intermed_zoom_coord: [
                        coord[0] +
                            Number.parseInt(
                                (i / n) * (new_coord[0] - coord[0])
                            ),
                        coord[1] +
                            Number.parseInt(
                                (i / n) * (new_coord[1] - coord[1])
                            ),
                    ],
                    set_intermed_zoom_scale: scale - (i / n) * (scale - 1),
                })
            }
            this.send_input_event_to_pipe({
                set_final_zoom_coord: new_coord,
                set_final_zoom_scale: 1.0,
            })
            this.pipeline_config.zoomScale = 1.0
            this.pipeline_config.zoomCrood = new_coord
            this.pipeline_config.inZoomMode = false
        }
    }

    _sync_pipe_config() {
        this.send_input_event('setAutoLowLightThreshold', 2)
        this.send_input_event(
            'isMotionDetection',
            this.pipeline_config.isMotionDetection
        )
        this.send_input_event(
            'isPersonDetection',
            this.pipeline_config.isPersonDetection
        )

        if (this.pipeline_config.isMotionDetection) {
            this.send_input_event(
                'setMotionThreshold',
                this.pipeline_config.sensitivity
            )
        } else {
            this.send_input_event('setMotionThreshold', 2)
        }
        if (this.pipeline_config.isPersonDetection) {
            this.send_input_event(
                'setPersonThreshold',
                this.pipeline_config.sensitivity
            )
        } else {
            this.send_input_event('setPersonThreshold', 2)
        }

        if (this.pipeline_config.isAutoLowLight === true) {
            this.send_input_event(
                'isAutoLowLight',
                this.pipeline_config.isAutoLowLight
            )
        } else {
            this.send_input_event(
                'isAutoLowLight',
                this.pipeline_config.isAutoLowLight
            )
            this.send_input_event(
                'isNightVision',
                this.pipeline_config.isNightVision
            )
        }
    }

    _postprocess_output(outputResult) {
        // console.log(`_postprocess_output:`, outputResult)
        return outputResult
    }

    _event_debug_view(outputResult) {
        const previewCanvas = this.previewCanvas
        const mainCanvas = this.mainCanvas
        const boxCanvas = this.boxCanvas
        const recordCanvas = this.recordCanvas
        const now = new Date().getTime()

        if (
            outputResult.detect_boxes !== undefined ||
            outputResult.motion_area_box !== undefined
        ) {
            this.boxCanvas
                .getContext('2d')
                .clearRect(0, 0, boxCanvas.width, boxCanvas.height)
        }

        if (
            outputResult.detect_boxes &&
            this.pipeline_config.isPersonDetectionBox
        ) {
            this.log('Find person! ', outputResult.detect_boxes)
            // trigger event record

            // if (outputResult.detect_boxes.length > 0)
            //     console.error('clearRect');
            //     this.boxCanvas
            //         .getContext('2d')
            //         .clearRect(0, 0, boxCanvas.width, boxCanvas.height)
            for (const box of outputResult.detect_boxes) {
                draw.drawPDBoxesToCanvas({
                    boxCanvas,
                    box: box,
                    sensitivity: 0.5,
                })
                // draw.drawFaceEllipse({
                //     boxCanvas,
                //     box: box,
                // })
            }
        }

        if (
            outputResult.motion_area_box !== undefined &&
            this.pipeline_config.isPersonDetectionBox &&
            this.pipeline_config.isMotionDetection
        ) {
            if (outputResult.motion_area_box['cls'] === 'motion_area') {
                let box = outputResult.motion_area_box

                draw.drawPDBoxesToCanvas({
                    boxCanvas,
                    box: box,
                    sensitivity: 0.5,
                })
            }
        }

        if (
            outputResult.viewport_box !== undefined &&
            this.pipeline_config.isPersonDetectionBox &&
            (this.pipeline_config.isMotionDetection ||
                this.pipeline_config.isPersonDetection)
        ) {
            if (outputResult.viewport_box['cls'] === 'viewport_area') {
                let box = outputResult.viewport_box
                box.x_min = Number.parseInt(box.x_min * boxCanvas.width)
                box.x_max = Number.parseInt(box.x_max * boxCanvas.width)
                box.y_min = Number.parseInt(box.y_min * boxCanvas.height)
                box.y_max = Number.parseInt(box.y_max * boxCanvas.height)
                draw.drawPDBoxesToCanvas({
                    boxCanvas,
                    box: box,
                    sensitivity: 0.5,
                })
            }
        }
    }

    _distribute_auto_event(outputResult) {
        const auto_events = [
            'auto_set_person_det',
            'auto_set_low_light',
            'set_low_light_filter',
            'switch_detect_target',
        ]
        const pipelines = this.pipelines
        // if (outputResult.pipeline_role == 'detection_pipeline')
        for (const event_name of auto_events) {
            if (outputResult[event_name] !== undefined) {
                for (const pipe_role in pipelines) {
                    console.log('outputResult   ', outputResult)
                    if (pipe_role != outputResult.pipeline_role) {
                        const pipe = pipelines[pipe_role]
                        let arg = {}
                        arg[event_name] = outputResult[event_name]
                        pipe.send_input_event(arg)
                    }
                }
            }
            delete outputResult[event_name]
        }
    }

    _event_multipex(outputResult) {
        /*
        Callback that handle graphic pipeline process results includes:
            # pipeline warmup progress
            # person detection bounding box
            # motion detection bounding box
            # video frame after apply zoom & low-light-filter & ...
        */
        const previewCanvas = this.previewCanvas
        const mainCanvas = this.mainCanvas
        const boxCanvas = this.boxCanvas
        const recordCanvas = this.recordCanvas
        const now = new Date().getTime()

        // this._distribute_auto_event(outputResult)
        outputResult = this._postprocess_output(outputResult)
        if (this.debug_view) this._event_debug_view(outputResult)
        // else this._event_face_view(outputResult)

        if (
            outputResult.detect_boxes &&
            this.pipeline_config.isPersonDetection &&
            this.eventStateHandler
        ) {
            if (outputResult.detect_boxes.length > 0) {
                this.log('Record trigger by: ', outputResult.detect_boxes)
                this.eventStateHandler.tick('person')
            } else {
                this.clearCanvas(boxCanvas)
                this.eventStateHandler.tick('nothing')
            }
        }

        if (
            outputResult.motion_area_box !== undefined &&
            !this.pipeline_config.isPersonDetection &&
            this.pipeline_config.isMotionDetection &&
            this.eventStateHandler
        ) {
            // NOTE: when person detection is on, recording should
            //       only be trigger by person detection signal.
            if (outputResult.motion_area_box['cls'] === 'motion_area') {
                this.eventStateHandler.tick('motion')
            } else {
                this.eventStateHandler.tick('nothing')
            }
        }

        if (outputResult.videoFrameUpdated) {
            const update_frame = outputResult.videoFrameUpdated

            // handleWindowResize()
            this.previewCanvasCtx.drawImage(
                update_frame,
                0,
                0,
                update_frame.width,
                update_frame.height,
                0,
                0,
                previewCanvas.width,
                previewCanvas.height
            )

            // matchSourceSize(this.mainCanvas, update_frame)
            this.mainCanvasCtx.drawImage(
                update_frame,
                0,
                0,
                update_frame.width,
                update_frame.height,
                0,
                0,
                mainCanvas.width,
                mainCanvas.height
            )

            this.recordCanvasCtx.drawImage(
                update_frame,
                0,
                0,
                update_frame.width,
                update_frame.height,
                0,
                0,
                recordCanvas.width,
                recordCanvas.height
            )
        }

        if (outputResult.videoCanvasUpdated !== undefined) {
            const videoCanvas = outputResult.videoCanvasUpdated
            this.handleWindowResize()
            this.previewCanvasCtx.drawImage(
                videoCanvas,
                0,
                0,
                videoCanvas.width,
                videoCanvas.height,
                0,
                0,
                previewCanvas.width,
                previewCanvas.height
            )

            // HACK: temperary way to check live state, not sure this is reliable or not
            if (
                this.liveCounter > 0 ||
                now - this.lastLiveCanvasUpdate > 3000
            ) {
                this.log(
                    'videoCanvasUpdated - live: ',
                    outputResult.frame_id,
                    `[${mainCanvas.width}x${mainCanvas.height}]`
                )
                this.lastLiveCanvasUpdate = now
                this.mainCanvasCtx.drawImage(
                    videoCanvas,
                    0,
                    0,
                    videoCanvas.width,
                    videoCanvas.height,
                    0,
                    0,
                    mainCanvas.width,
                    mainCanvas.height
                )
            }

            if (
                (this.pipeline_config.isMotionDetection ||
                    this.pipeline_config.isPersonDetection) &&
                this.eventStateHandler
            ) {
                this.log(
                    'recordCanvasUpdated: ',
                    outputResult.frame_id,
                    `[${recordCanvas.width}x${recordCanvas.height}]`
                )
                // this.recordCanvasCtx.drawImage(
                //     videoCanvas,
                //     0,
                //     0,
                //     videoCanvas.width,
                //     videoCanvas.height,
                //     0,
                //     0,
                //     recordCanvas.width,
                //     recordCanvas.height
                // )
                this.eventStateHandler._record_manager.buffer_holder.append(
                    videoCanvas
                )
            }
        }

        if (outputResult.auto_set_low_light !== undefined) {
            this.log('Auto Set Low Light!', outputResult.auto_set_low_light)
        }

        if (outputResult.auto_set_person_det !== undefined) {
            this.log('Auto Set Person Det!', outputResult.auto_set_person_det)
        }
    }

    clearCanvas(canvas) {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
    }
}

export class GraphicHandlerWithWorker extends GraphicHandler {
    constructor({
        video,
        videoCanvas,
        boxCanvas,
        previewCanvas,
        mainCanvas,
        recordCanvas,
        handleWindowResize,
        eventStateHandler,

        isMotionDetection = false,
        isPersonDetection = false,
        isPersonDetectionBox = true,
        isAutoLowLight = false,
        isNightVision = false,
        sensitivity = 2,
        isFree = true,
        deviceContext = undefined,
    }) {
        super({
            video,
            videoCanvas,
            boxCanvas,
            previewCanvas,
            mainCanvas,
            recordCanvas,
            handleWindowResize,
            eventStateHandler,

            isMotionDetection,
            isPersonDetection,
            isPersonDetectionBox,
            isAutoLowLight,
            isNightVision,
            sensitivity,
            isFree,
            deviceContext,
        })

        // this._create_worker_pipeline(video, videoCanvas, boxCanvas)
        this.pipelines = {
            detection_pipeline: this.pipeline,
            visual_pipeline: this.vis_pipeline,
            // worker_pipeline: this.worker_pipeline,
        }
    }

    send_input_event_to_pipe(event) {
        this.pipeline.send_input_event(event)
        this.vis_pipeline.send_input_event(event)
        // this.worker_pipeline.send_input_event(event)
    }

    _create_worker_pipeline(video, videoCanvas, boxCanvas) {
        // const worker = new TfWorker()
        const worker = null

        const dummy_video_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )
        const dummy_box_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )

        const worker_pipeline = new Empty(
            video,
            dummy_video_canvas,
            dummy_box_canvas,
            worker,
            () => {}
        )
        this.worker_pipeline = worker_pipeline
    }

    _create_detection_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let detection_pipeline = null
        const worker = new TfWorker()
        const dummy_video_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )
        const dummy_box_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )

        if (!isFree) {
            detection_pipeline = new DualWieldPipe(
                video,
                dummy_video_canvas,
                dummy_box_canvas,
                worker,
                (res) => {
                    res.pipeline_role = 'detection_pipeline'
                    this._event_multipex(res)
                },
                5
            )
        } else {
            detection_pipeline = new FreeDualWieldPipe(
                video,
                dummy_video_canvas,
                dummy_box_canvas,
                worker,
                (res) => {
                    res.pipeline_role = 'detection_pipeline'
                    this._event_multipex(res)
                }
            )
        }
        this.pipeline = detection_pipeline
    }

    _event_multipex(outputResult) {
        super._event_multipex(outputResult)

        if (outputResult.frame_timestamp) {
            const stamp = outputResult.frame_timestamp
            this.log_jitter(outputResult.frame_timestamp)
            // console.log('frame jitter time', stamp.process_pipe, new Date().getTime() - stamp.timestamp)
        }
    }

    clearFaceBoxes() {
        this.faceBoxes = {}
    }
}

export class GraphicHandlerWith2Worker extends GraphicHandlerWithWorker {
    constructor({
        video,
        videoCanvas,
        boxCanvas,
        previewCanvas,
        mainCanvas,
        recordCanvas,
        handleWindowResize,
        eventStateHandler,

        isMotionDetection = false,
        isPersonDetection = false,
        isPersonDetectionBox = true,
        isAutoLowLight = false,
        isNightVision = false,
        sensitivity = 2,
        isFree = true,
        deviceContext = undefined,
    }) {
        super({
            video,
            videoCanvas,
            boxCanvas,
            previewCanvas,
            mainCanvas,
            recordCanvas,
            handleWindowResize,
            eventStateHandler,

            isMotionDetection,
            isPersonDetection,
            isPersonDetectionBox,
            isAutoLowLight,
            isNightVision,
            sensitivity,
            isFree,
            deviceContext,
        })
    }

    _create_detection_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let detection_pipeline = null
        const worker = new TfWorker()
        const dummy_video_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )
        const dummy_box_canvas = new OffscreenCanvas(
            videoCanvas.width,
            videoCanvas.height
        )

        detection_pipeline = new DualWieldPipe(
            video,
            dummy_video_canvas,
            dummy_box_canvas,
            worker,
            (res) => {
                res.pipeline_role = 'detection_pipeline'
                this._event_multipex(res)
            }
        )
        detection_pipeline.fps = 10
        this.pipeline = detection_pipeline
    }

    _create_visual_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let vis_pipeline = null
        vis_pipeline = new SlimPipe(
            video,
            videoCanvas,
            boxCanvas,
            undefined,
            (res) => {
                res.pipeline_role = 'visual_pipeline'
                this._event_multipex(res)
            }
        )

        this.vis_pipeline = vis_pipeline
    }
}

export class GraphicTesterGL extends GraphicHandler {
    constructor({
        video,
        videoCanvas,
        boxCanvas,
        previewCanvas,
        mainCanvas,
        recordCanvas,
        handleWindowResize,
        eventStateHandler,

        isMotionDetection = false,
        isPersonDetection = false,
        isPersonDetectionBox = true,
        isAutoLowLight = false,
        isNightVision = false,
        sensitivity = 2,
        isFree = true,
        deviceContext = undefined,
    }) {
        super({
            video,
            videoCanvas,
            boxCanvas,
            previewCanvas,
            mainCanvas,
            recordCanvas,
            handleWindowResize,
            eventStateHandler,

            isMotionDetection,
            isPersonDetection,
            isPersonDetectionBox,
            isAutoLowLight,
            isNightVision,
            sensitivity,
            isFree,
            deviceContext,
        })
    }

    _create_detection_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let detection_pipeline = new Empty(
            video,
            videoCanvas,
            boxCanvas,
            undefined,
            (res) => {
                res.pipeline_role = 'detection_pipeline'
                this._event_multipex(res)
            }
        )

        this.pipeline = detection_pipeline
    }

    _create_visual_pipeline(video, videoCanvas, boxCanvas, isFree) {
        let visual_pipeline = null
        visual_pipeline = new DevSlimPipe(
            video,
            videoCanvas,
            boxCanvas,
            undefined,
            (res) => {
                res.pipeline_role = 'visual_pipeline'
                this._event_multipex(res)
            }
        )
        visual_pipeline.fps = 5

        this.vis_pipeline = visual_pipeline
    }
}
